// Первым импортом: перехватчики эмуляции сети должны встать до создания supabase-клиента (IMGM-1435).
import './setup-network-chaos';
import './index.css';
import './styles/tippy.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { initAmplitude } from 'shared/analytics';
import { loadAppFonts } from 'shared/fonts';
import { activateLocale, detectLocale } from 'shared/i18n';

import App from './App';

initAmplitude();
loadAppFonts();

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

const Root =
  process.env.NODE_ENV === 'development' ? (
    <App />
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

// Рендер — только после активации языка: иначе на английской машине мигнёт русский интерфейс.
// `activateLocale` не бросает: если каталог не загрузился, он сам включает русский из бандла.
activateLocale(detectLocale()).finally(() => root.render(Root));
